/* ==========================================================================
   Build Your Box — one bundle, one line in the cart

   The builder stamps every piece it adds with a `_byb_bundle` line item
   property holding one id per bundle. Two things then read that:

   1. snippets/c-cart-bundle.liquid — the theme's own drawer and /cart page.
   2. This file — the UpCart drawer, which is an app and never runs our Liquid.

   UpCart renders into the page's own DOM (no iframe), and every line carries
   the Shopify line item key as its element id:

       <div class="upcart-product-item" id="48126069178585:ad8c60…">
         <h3 class="upcart-product-title">…</h3>
         <div class="upcart-item-option" data-upcart-item-option-category="Color" …>
         <div class="upcart-item-properties-anchor-before"></div>
         <div class="upcart-item-properties">
           <p class="upcart-item-property"><strong>_byb_bundle:</strong><span>…</span></p>
         </div>
         <div class="upcart-item-properties-anchor-after"></div>
       </div>

   so each rendered line can be matched back to /cart.js exactly. UpCart prints
   every property, underscored ones included, which is why the raw bundle id was
   showing under each product.

   UpCart is React: its own nodes are never moved or removed here. A header is
   inserted before the group and a footer after it, both as plain siblings, and
   the pieces themselves are only given classes. If React throws the injected
   nodes away on a re-render, the observer puts them back.
   ========================================================================== */

(function () {
  'use strict';

  if (window.__cCartBundleReady) return;
  window.__cCartBundleReady = true;

  var BUNDLE_PROP = '_byb_bundle';
  var NAME_PROP = '_byb_name';
  var SHORT_PROP = '_byb_short';
  // The builder page the bundle was made on — Edit's destination.
  var EDIT_PROP = '_byb_edit';
  var MARK = 'data-byb-injected';
  // Shared with assets/c-build-your-box.js, which keeps the builder's copy of
  // the bundle there so Edit has something to open.
  var BUILDER_STATE_KEY = 'c-byb-state';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  root = root.replace(/\/$/, '');

  function cartUrl(path) {
    return root + path;
  }

  /* A line item property is shopper-writable in principle, so Edit only ever
     points at a same-origin path: no protocol, no protocol-relative //host. */
  function editHref(path, bundleId) {
    if (!path || path.charAt(0) !== '/' || path.charAt(1) === '/') return '';
    return path + (path.indexOf('?') === -1 ? '?' : '&') + 'byb_edit=' + encodeURIComponent(bundleId);
  }

  /* Removing the bundle from the cart is the one thing that empties the builder:
     it keeps its copy across "Add to cart" precisely so Edit can reopen it. */
  function forgetBuilderState(bundleId) {
    try {
      // Only this bundle's copy: a second bundle in the cart, or a selection
      // still being built, is none of this removal's business.
      var raw = window.localStorage.getItem(BUILDER_STATE_KEY);
      var state = raw ? JSON.parse(raw) : null;
      if (state && state.bundleId === bundleId) {
        window.localStorage.removeItem(BUILDER_STATE_KEY);
      }
    } catch (error) {
      /* private mode: the builder falls back to reading the cart */
    }
    document.documentElement.dispatchEvent(
      new CustomEvent('byb:bundleremoved', {
        bubbles: true,
        cancelable: false,
        detail: { bundleId: bundleId }
      })
    );
  }

  function money(cents, currency) {
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency || 'USD'
      }).format(cents / 100);
    } catch (error) {
      return (cents / 100).toFixed(2);
    }
  }

  /* ------------------------------------------------- remove a whole bundle */

  /* One request, not one per piece: removing them one at a time would drop the
     cart below the discount threshold in between, and a failed request halfway
     through would leave a broken half-bundle behind.

     The keys are looked up now rather than baked into the button when it was
     drawn. A line item key changes whenever its line changes, so a button drawn
     before the shopper touched anything else was posting keys the cart no longer
     had: Shopify accepts the request, silently changes nothing, and UpCart
     redraws — which reads exactly like the bundle being removed and the products
     coming back on their own. */
  /* Measured on this shop: UpCart patches neither fetch nor XHR and answers none
     of the usual cart events, so it never notices a change made behind its back.
     That is why the Cart API path alone removed the lines but left the rows on
     screen. Detect it and drive its own controls instead. */
  function hasCartApp() {
    if (window.UpCart || window.upcart || window.Rebuy) return true;
    return !!document.querySelector('#CartPopup, [id^="upcart"], [class*="upcart-cart"], #rebuy-cart');
  }

  /* Only the theme's own drawer needs telling; waking it while a cart app owns
     the cart makes it re-render from state it no longer controls. */
  function announce() {
    if (hasCartApp()) return;
    document.documentElement.dispatchEvent(
      new CustomEvent('theme:cartchanged', { bubbles: true, cancelable: false })
    );
  }

  function postUpdates(updates) {
    return fetch(cartUrl('/cart/update.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ updates: updates })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('cart update failed');
        return response.json();
      })
      .then(function () {
        cache.items = null;
        announce();
        schedule();
      });
  }

  function keysInCart(cart, bundleId) {
    var keys = [];
    cart.items.forEach(function (item) {
      if (item.properties && item.properties[BUNDLE_PROP] === bundleId) keys.push(item.key);
    });
    return keys;
  }

  /* Two independent sources for the same answer, because getting this wrong
     leaves the shopper's cart untouched while the bundle appears to vanish:
     the cart's own properties, and the ids UpCart put on the rows we grouped
     (a row id IS the line item key). Both are read at click time. */
  function keysToRemove(cart, bundleId) {
    var keys = keysInCart(cart, bundleId);
    var live = {};
    cart.items.forEach(function (item) {
      live[item.key] = true;
    });
    document.querySelectorAll('[data-byb-bundle-id="' + bundleId + '"]').forEach(function (node) {
      if (node.id && live[node.id] && keys.indexOf(node.id) === -1) keys.push(node.id);
    });
    return keys;
  }

  /* A failure here used to be invisible: the button came back enabled and the
     shopper was left guessing whether anything happened. Say so instead, and
     keep the reason on window.__bybBundleLog for whoever has to debug it. */
  function reportFailure(button, reason) {
    window.__bybBundleLog = window.__bybBundleLog || [];
    window.__bybBundleLog.push({ reason: reason, at: new Date().toISOString() });

    if (!button) return;
    button.removeAttribute('disabled');

    var foot = button.parentNode;
    if (!foot) return;
    var existing = foot.querySelector('.c-upcart-bundle__error');
    if (existing) existing.remove();
    var note = el('span', 'c-upcart-bundle__error', "Couldn't remove the bundle. Please refresh and try again.");
    note.setAttribute('data-byb-reason', reason);
    foot.insertBefore(note, button);
  }

  /* UpCart neither patches fetch/XHR nor answers any of the usual cart events —
     measured on the shop: removing a line behind its back left the cart at one
     item while its drawer still showed two. Calling the Cart API directly is
     therefore only half a removal: the lines go, the rows stay on screen, and
     the bundle "loses its layout while the products remain", which is exactly
     what it looked like.

     So drive UpCart's own delete button instead, one row at a time. It owns the
     request and its own re-render, and a display:none button still answers a
     programmatic click. The Cart API stays as the fallback for the theme's own
     drawer, where no such button exists. */
  function trashIn(row) {
    return row.querySelector('[class*="TrashButton"], [class*="upcart-item-remove"]');
  }

  /* UpCart's own refresh hook. It never notices a cart change made behind its
     back — no patched fetch, no events — so without this the lines went but the
     rows stayed on screen. Clicking its delete button per row worked, and cost
     a redraw each time; this is one call. */
  function refreshCartApp() {
    if (typeof window.upcartRefreshCart !== 'function') return false;
    try {
      window.upcartRefreshCart();
      return true;
    } catch (error) {
      return false;
    }
  }

  /* Fallback for an UpCart old enough to lack the hook: drive its delete button
     one row at a time, which forces its own re-render. Slower, hence second. */
  function removeViaUpCartClicks(bundleId, button) {
    var rows = [].slice.call(document.querySelectorAll('[data-byb-bundle-id="' + bundleId + '"]'));
    if (!rows.length) return removeViaApi(bundleId, button);

    return rows.reduce(function (chain, row) {
      return chain.then(function () {
        var live = document.getElementById(row.id);
        var trash = live && trashIn(live);
        if (!trash) return null;
        trash.click();
        return new Promise(function (resolve) {
          setTimeout(resolve, 700);
        });
      });
    }, Promise.resolve()).then(function () {
      cache.items = null;
      schedule();
      return fetch(cartUrl('/cart.js'), { credentials: 'same-origin' }).then(function (r) {
        return r.json();
      });
    }).then(function (cart) {
      if (keysInCart(cart, bundleId).length) return removeViaApi(bundleId, button);
      forgetBuilderState(bundleId);
      return null;
    });
  }

  function removeViaApi(bundleId, button) {
    return fetch(cartUrl('/cart.js'), { credentials: 'same-origin' })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        var keys = keysToRemove(cart, bundleId);
        if (!keys.length) throw new Error('no lines in the cart carry this bundle id');
        var updates = {};
        keys.forEach(function (key) {
          updates[key] = 0;
        });
        return postUpdates(updates);
      })
      .then(function () {
        return fetch(cartUrl('/cart.js'), { credentials: 'same-origin' }).then(function (r) {
          return r.json();
        });
      })
      .then(function (cart) {
        if (keysInCart(cart, bundleId).length) {
          reportFailure(button, 'lines survived the cart API');
          return;
        }
        forgetBuilderState(bundleId);
      });
  }

  function removeBundle(bundleId, button) {
    if (!bundleId) return;
    if (button) button.setAttribute('disabled', 'disabled');

    // One request to empty the bundle, one call to make the cart app redraw.
    // Only fall back to driving its buttons if that hook is not there.
    if (!hasCartApp() || typeof window.upcartRefreshCart === 'function') {
      return removeViaApi(bundleId, button)
        .then(function () {
          refreshCartApp();
        })
        .catch(function (error) {
          reportFailure(button, (error && error.message) || 'request failed');
        });
    }

    return removeViaUpCartClicks(bundleId, button).catch(function (error) {
      reportFailure(button, (error && error.message) || 'request failed');
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-byb-remove-bundle]');
    if (!button) return;
    event.preventDefault();
    removeBundle(button.getAttribute('data-byb-remove-bundle'), button);
  });

  /* ------------------------------------------------------- the UpCart pass */

  var cache = { items: null, currency: null, pending: false };

  /* Always a fresh read. The debounce below already collapses a burst of DOM
     mutations into one pass, so this is one small request per redraw — cheaper
     than the class of bug that comes from drawing totals off a stale cart. */
  function fetchCart() {
    if (cache.pending) return cache.pending;
    cache.pending = fetch(cartUrl('/cart.js'), { credentials: 'same-origin' })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        cache.items = {};
        cart.items.forEach(function (item) {
          cache.items[item.key] = item;
        });
        cache.currency = cart.currency;
        cache.pending = false;
        return cache.items;
      })
      .catch(function () {
        cache.pending = false;
        return null;
      });
    return cache.pending;
  }

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    node.setAttribute(MARK, '');
    return node;
  }

  function buildHeader(group) {
    var head = el('div', 'c-upcart-bundle__head');
    var title = el('span', 'c-upcart-bundle__title', group.name);
    var count = el('span', 'c-upcart-bundle__count', String(group.count));
    var prices = el('div', 'c-upcart-bundle__prices');
    prices.appendChild(el('span', 'c-upcart-bundle__total', money(group.total, cache.currency)));
    if (group.saving > 0) {
      prices.appendChild(el('span', 'c-upcart-bundle__compare', money(group.original, cache.currency)));
    }
    head.appendChild(title);
    head.appendChild(count);
    head.appendChild(prices);
    return head;
  }

  function trashIcon() {
    var ns = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(ns, 'svg');
    svg.setAttribute('viewBox', '0 0 16 16');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('class', 'c-upcart-bundle__trash');
    var path = document.createElementNS(ns, 'path');
    path.setAttribute('d', 'M2.5 4h11M6.5 4V2.5h3V4M4 4l.7 9a1 1 0 0 0 1 .9h4.6a1 1 0 0 0 1-.9L12 4M6.6 6.8v4.4M9.4 6.8v4.4');
    path.setAttribute('fill', 'none');
    path.setAttribute('stroke', 'currentColor');
    path.setAttribute('stroke-width', '1.2');
    path.setAttribute('stroke-linecap', 'round');
    path.setAttribute('stroke-linejoin', 'round');
    svg.appendChild(path);
    return svg;
  }

  /* Edit and Remove, nothing else: the saving is already told by the header's
     struck-through total, and the design has no second line for it. */
  function buildFoot(group) {
    var foot = el('div', 'c-upcart-bundle__foot');

    // A plain link, so it survives UpCart's own re-render and behaves like one
    // (middle-click, open in a new tab) instead of needing a handler.
    var href = editHref(group.editUrl, group.id);
    if (href) {
      var edit = el('a', 'c-upcart-bundle__edit', 'Edit');
      edit.href = href;
      foot.appendChild(edit);
    }

    var button = el('button', 'c-upcart-bundle__remove');
    button.type = 'button';
    button.setAttribute('data-byb-remove-bundle', group.id);
    button.appendChild(trashIcon());
    button.appendChild(el('span', null, 'Remove bundle'));
    foot.appendChild(button);
    return foot;
  }

  function enhance(items) {
    var section = document.querySelector('.upcart-products-section');
    if (!section || !items) return;

    // Machinery, not something the shopper chose.
    section.querySelectorAll('.upcart-item-property').forEach(function (row) {
      var label = row.querySelector('strong');
      if (label && label.textContent.trim().charAt(0) === '_') {
        row.setAttribute('hidden', 'hidden');
      }
    });

    section.querySelectorAll('[' + MARK + ']').forEach(function (node) {
      node.remove();
    });

    var groups = {};
    var order = [];

    section.querySelectorAll('.upcart-product-item').forEach(function (node) {
      node.classList.remove('is-byb-bundle', 'is-byb-first', 'is-byb-last');
      node.removeAttribute('data-byb-bundle-id');

      var line = items[node.id];
      var id = line && line.properties && line.properties[BUNDLE_PROP];
      if (!id) return;

      if (!groups[id]) {
        groups[id] = {
          id: id,
          nodes: [],
          keys: [],
          count: 0,
          total: 0,
          original: 0,
          name: line.properties[NAME_PROP] || 'Build Your Own Bundle',
          editUrl: line.properties[EDIT_PROP] || ''
        };
        order.push(id);
      }

      var group = groups[id];
      group.nodes.push(node);
      group.keys.push(line.key);
      group.count += line.quantity;
      group.total += line.final_line_price;
      group.original += line.original_line_price;

      // The merchant's short name, where the full title would wrap.
      var short = line.properties[SHORT_PROP];
      var title = node.querySelector('.upcart-product-title');
      if (short && title && title.textContent.trim() !== short) {
        title.textContent = short;
      }

      // The stepper is hidden on a bundled line, so four of one colourway would
      // otherwise read as one. UpCart leaves these anchor divs empty precisely
      // for injected content, which keeps us out of its own render tree.
      if (line.quantity > 1) {
        // Inside the colour chip's own row, so it reads as part of it:
        // "Color: Sapphire  x 2". The anchor UpCart provides is a block of its
        // own, which put the count on a line by itself. Appending after React's
        // last child is the safe form of injection — it never reorders anything
        // React is tracking, and this pass rebuilds it from scratch anyway.
        var slot = node.querySelector('.upcart-item-option') ||
          node.querySelector('.upcart-item-properties-anchor-before');
        if (slot) slot.appendChild(el('span', 'c-upcart-bundle__qty', '\u00d7 ' + line.quantity));
      }
    });

    order.forEach(function (id) {
      var group = groups[id];
      group.saving = group.original - group.total;

      var first = group.nodes[0];
      var last = group.nodes[group.nodes.length - 1];

      // The fill is an UpCart theme setting the merchant picks, so copy it off a
      // real line. The border is not: the design asks for one grey rule around
      // the whole bundle, which the stylesheet owns.
      var box = window.getComputedStyle(first);
      var background = box.backgroundColor;

      group.nodes.forEach(function (node, index) {
        node.classList.add('is-byb-bundle');
        node.setAttribute('data-byb-bundle-id', group.id);
        if (index === 0) node.classList.add('is-byb-first');
        if (index === group.nodes.length - 1) node.classList.add('is-byb-last');
      });

      var head = buildHeader(group);
      var foot = buildFoot(group);
      [head, foot].forEach(function (node) {
        node.style.setProperty('--c-byb-upcart-bg', background);
      });

      first.parentNode.insertBefore(head, first);
      if (last.nextSibling) {
        last.parentNode.insertBefore(foot, last.nextSibling);
      } else {
        last.parentNode.appendChild(foot);
      }
    });
  }

  /* UpCart re-renders on every cart change and on open; re-run after it settles
     rather than trying to predict when it is done. */
  var timer = null;
  var applying = false;

  function schedule() {
    if (applying) return;
    if (timer) clearTimeout(timer);
    timer = setTimeout(function () {
      fetchCart().then(function (items) {
        applying = true;
        try {
          enhance(items);
        } finally {
          window.requestAnimationFrame(function () {
            applying = false;
          });
        }
      });
    }, 120);
  }

  function start() {
    if (!document.body) return;
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    schedule();
  }

  // A cart request from anywhere (the builder, a PDP, UpCart itself) invalidates
  // the totals we just drew.
  ['theme:cartchanged', 'cart:updated', 'upcart:cart:updated'].forEach(function (name) {
    document.addEventListener(name, function () {
      cache.items = null;
      schedule();
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
